/**
 * GLOBAL CONFIGURATION
 * Central source of truth for all application constants.
 */

// CORE
export const APP_NAME = "PrimeApuesta";
export const ADMIN_UID = "MB2HoMyzU3YChLhDifcpHDook6L2"; // Owner

// THEME & UI
export const THEME_COLORS = {
    GOLD: {
        primary: '#D4AF37',
        text: 'text-[#D4AF37]',
        bg: 'bg-[#D4AF37]',
        border: 'border-[#D4AF37]',
        shadow: 'shadow-[#D4AF37]/30',
        glow: 'shadow-[0_0_15px_rgba(212,175,55,0.4)]'
    },
    BLUE: {
        primary: '#3B82F6',
        text: 'text-blue-500',
        bg: 'bg-blue-600',
        border: 'border-blue-500',
        shadow: 'shadow-blue-600/30',
        glow: 'shadow-[0_0_15px_rgba(59,130,246,0.4)]'
    }
};

// CURRENCY & ECONOMY
export const CURRENCY_CONFIG = {
    BS: { label: 'Bolivianos', symbol: 'Bs', code: 'BS', color: 'text-emerald-400', bg: 'bg-emerald-500/10' },
    USDT: { label: 'Tether USDT', symbol: '₮', code: 'USDT', color: 'text-blue-400', bg: 'bg-blue-500/10' },
    BONUS: { label: 'Saldo Bono', symbol: 'Bs', code: 'BONUS', color: 'text-purple-400', bg: 'bg-purple-500/10' }
};

// GAME LIMITS & BETTING
export const GAME_LIMITS = {
    MIN_BET: 1, // Bs
    MAX_BET_CASINO: 1000,
    MAX_BET_SPORTS: 5000,
    MAX_MULTIPLIER_CRASH: 100, // Auto-cashout limit cap
};

// CATEGORÍA VIP — MUNDIAL 2026 (id 1000). Fuente única para sidebar/lobby.
// Debe renderizarse SIEMPRE primera (índice 0). Su data vive en el pipeline de
// DEPORTES (SportsView/getEvents), por lo que actúa como acceso directo a esa sección.
export const WORLD_CUP_SPORT = { id: 1000, name: 'Mundial 2026', icon: 'fa-solid fa-trophy', popular: true };

// SPORTS METADATA
export const SPORTS_CONFIG = [
    { id: 1, name: 'Fútbol', icon: 'fa-solid fa-futbol', popular: true },
    { id: 2, name: 'Tenis', icon: 'fa-solid fa-table-tennis-paddle-ball', popular: true },
    { id: 3, name: 'Baloncesto', icon: 'fa-solid fa-basketball', popular: true },
    { id: 4, name: 'Hockey Hielo', icon: 'fa-solid fa-hockey-puck', popular: true },
    { id: 5, name: 'Béisbol', icon: 'fa-solid fa-baseball', popular: true },
    { id: 6, name: 'Fútbol Americano', icon: 'fa-solid fa-football', popular: false },
    { id: 7, name: 'Voleibol', icon: 'fa-solid fa-volleyball', popular: false },
    { id: 9, name: 'Fútbol Australiano', icon: 'fa-solid fa-football', popular: false },
    { id: 10, name: 'Vóley Playa', icon: 'fa-solid fa-umbrella-beach', popular: false },
    { id: 12, name: 'Futsal', icon: 'fa-solid fa-futbol', popular: false },
    { id: 13, name: 'Rugby', icon: 'fa-solid fa-football', popular: false },
    { id: 14, name: 'Bádminton', icon: 'fa-solid fa-feather', popular: false },
    { id: 16, name: 'Balonmano', icon: 'fa-solid fa-hand-holding', popular: false },
    { id: 17, name: 'Tenis de Mesa', icon: 'fa-solid fa-table-tennis', popular: false },
    { id: 19, name: 'Criquet', icon: 'fa-solid fa-baseball-bat-ball', popular: false },
    { id: 25, name: 'Waterpolo', icon: 'fa-solid fa-water', popular: false },
    { id: 34, name: 'Esquí Alpino', icon: 'fa-solid fa-person-skiing', popular: false },
    { id: 35, name: 'Bandy', icon: 'fa-solid fa-hockey-puck', popular: false },
    { id: 74, name: 'Tiro con Arco', icon: 'fa-solid fa-bullseye', popular: false },
    { id: 75, name: 'Atletismo', icon: 'fa-solid fa-person-running', popular: false },
    { id: 84, name: 'Canicas', icon: 'fa-solid fa-circle-dot', popular: false },
    { id: 85, name: 'Carrera Aérea', icon: 'fa-solid fa-plane', popular: false },
    { id: 87, name: 'Natación', icon: 'fa-solid fa-person-swimming', popular: false },
    { id: 89, name: 'Natación Artística', icon: 'fa-solid fa-water', popular: false },
    { id: 301, name: 'Arena of Valor', icon: 'fa-solid fa-gamepad', popular: false }
];

export const MARKET_TRANSLATIONS = {
    '1X2': 'Ganador del Partido',
    'h2h': 'Ganador (2 Opciones)',
    'double_chance': 'Doble Oportunidad',
    'total': 'Total de Goles/Puntos',
    'over_under': 'Más/Menos de',
    'handicap': 'Handicap',
    'both_teams_to_score': 'Ambos Equipos Anotan',
    'correct_score': 'Marcador Exacto',
    'half_time_full_time': 'Descanso / Final'
};
